import { render, staticRenderFns } from "./ThirdPartyReceiversTable.vue?vue&type=template&id=5691f6d8&"
import script from "./ThirdPartyReceiversTable.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyReceiversTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports